
import { createSelector } from 'reselect';
import { immutableToJS } from '../../devUtils/commonUtils';

const selectIndusindMinKycDomain = (state) => state.get('indusindMinKyc');
const selectIndusindMinKycDetails = () => createSelector(
  selectIndusindMinKycDomain,
  (IndusindMinKyc) => IndusindMinKyc,
);

const selectIsLoading = () => createSelector(
  selectIndusindMinKycDomain,
  (IndusindMinKyc) => IndusindMinKyc.get('isLoading'));

const select_indusindMinKycCities = () => createSelector(
  selectIndusindMinKycDomain,
  (IndusindMinKyc) => immutableToJS(IndusindMinKyc.get('indusindMinKycCities')),
);

const select_indusindMinKycUserInfo = () => createSelector(
  selectIndusindMinKycDomain,
  (IndusindMinKyc) => immutableToJS(IndusindMinKyc.get('indusindMinKycUserInfo')),
);

const select_indusindMinKycUser = () => createSelector(
  selectIndusindMinKycDomain,
  (IndusindMinKyc) => immutableToJS(IndusindMinKyc.get('indusindMinKycUserUpdateSuccess')),
);

const select_indusindMinKycUserDetails = () => createSelector(
  selectIndusindMinKycDomain,
  (IndusindMinKyc) => immutableToJS(IndusindMinKyc.get('indusindMinKycUserDetails')),
);

const select_dedupeVerifySuccess = () => createSelector(
  selectIndusindMinKycDomain,
  (IndusindMinKyc) => immutableToJS(IndusindMinKyc.get('dedupeVerifySuccess')),
);

export {
  selectIndusindMinKycDetails,
  selectIsLoading,
  select_indusindMinKycCities,
  select_indusindMinKycUserInfo,
  select_indusindMinKycUser,
  select_indusindMinKycUserDetails,
  select_dedupeVerifySuccess,
};



// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/selectors.js